<template>
  <div style="padding: 5px;">
    <a-spin tip="Loading..." :spinning="loading">
      <a-icon slot="indicator" type="loading" />
      <div style="margin-bottom: 10px; text-align: right;">
        <a-button v-if="data.length > 0" icon="export" @click="onExport">
          Export
        </a-button>
      </div>
      <div class="spin-content">
        <table id="export-user" class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Username</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Department</th>
              <th scope="col">Position</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, idx) in data" :key="user.id">
              <th scope="row">{{ idx + 1 }}</th>
              <td>
                {{ user.username }}
              </td>
              <td>
                {{ user.fullname }}
              </td>
              <td>
                {{ user.email }}
              </td>
              <td>
                {{ user.department && user.department.name }}
              </td>
              <td>
                {{ user.position && user.position.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </a-spin>
  </div>
</template>
<script>
import moment from "moment";
import viewExportExcelService from "@/services/viewExportExcel.js";
import { formatCell } from "./services/export";

import query from "./data/getData";

const limit = 100;
const startPage = 1;

function getDurationShiftEmployee(user) {
  return (
    user?.workShift?.duration || user?.branchLocation?.mainShift?.duration || 1
  );
}

export default {
  components: {},
  data() {
    return {
      data: [],
      loading: false,
      page: startPage,
    };
  },
  computed: {
    exportFileName() {
      return new moment().format("DD_MM_YYY_HHmmss") + "_user";
    },
  },
  async created() {
    await this.getListPagination(this.page);
    await this.onExport();
    window.close();
  },
  methods: {
    getDurationShiftEmployee,
    getAllUser(currentPage) {
      return this.$apollo.query({
        query: query.queryGetAllUser,
        variables: {
          limit,
          page: currentPage,
        },
        fetchPolicy: "no-cache",
      });
    },
    async getListPagination(currentPage) {
      try {
        this.loading = true;
        const { data } = await this.getAllUser(currentPage);
        if (data?.users?.length > 0) {
          this.data = (this.data || []).concat(data.users);
        }
        if (data?.users?.length === limit) {
          await this.getListPagination(currentPage + 1);
        }
        this.loading = false;
      } catch (err) {
        console.error("Error", err);
      }
    },
    async onExport() {
      try {
        await viewExportExcelService({
          filename: this.exportFileName,
          tableId: "export-user",
          formatCellFnc: (sheets) => {
            formatCell(sheets);
          },
        });
      } catch (err) {
        console.error("Error export", err);
      }
    },
  },
};
</script>
